document.addEventListener("DOMContentLoaded", () => {

    function initBadge() {

        const dropdown = document.querySelector(".shopify_subscriptions_app_block .group_dropdown");
        const group = document.querySelector(".shopify_subscriptions_app_block .subscription_group:nth-child(2)");

        if (!dropdown || !group) return false;

        let badge = group.querySelector(".subscription-save-badge");

        if (!badge) {
            badge = document.createElement("div");
            badge.className = "subscription-save-badge";
            group.appendChild(badge);
        }

        function updateBadge() {

            const option = dropdown.options[dropdown.selectedIndex];

            if (!option) return;

            const match = option.text.match(/(\d+)%/);

            badge.textContent = match ? `Save ${match[1]}%!` : "";

        }

        updateBadge();

        dropdown.removeEventListener("change", updateBadge);
        dropdown.addEventListener("change", updateBadge);

        return true;

    }

    // Widget loads asynchronously, so retry a few times.
    let tries = 0;

    const timer = setInterval(() => {

        tries++;

        if (initBadge() || tries > 20) {

            clearInterval(timer);

        }

    }, 500);

});



document.addEventListener('DOMContentLoaded', function () {
  const oneTimeRadio = document.getElementById(
    'AWm1lTkk5SGxJbVVQM__subscriptions_app_block_FkBb99_one_time_purchase'
  );
  if (oneTimeRadio && !oneTimeRadio.checked) {
    oneTimeRadio.checked = true;
    oneTimeRadio.dispatchEvent(new Event('change', { bubbles: true }));
  }
});